<template>
  <div
    class="modal fade modal-login"
    id="loginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="row align-items-stretch no-gutters">
            <div class="col-12 col-lg-6">
              <div class="modal-login__col" />
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column">
              <div class="modal-header">
                <h4>{{ $t("connexion") }}</h4>
                <a
                  href="#"
                  class="icon icon-cross"
                  @click.prevent.stop="closeModal"
                  >{{ $t("close") }}</a
                >
              </div>
              <ValidationObserver ref="observer" v-slot="{ invalid }">
                <form method="post" @submit.prevent="login">
                  <div class="modal-body">
                    <div class="form-group">
                      <validation-provider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <label for="signin-email"
                          >{{ $t("form.email") }}
                          <sup class="text-danger">*</sup></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors.length }"
                          :placeholder="$t('form.email')"
                          name="email"
                          v-model="email"
                          id="signin-email"
                        />
                        <span v-cloak class="text-danger small">{{
                          errors[0]
                        }}</span>
                      </validation-provider>
                    </div>
                    <div class="form-group">
                      <validation-provider
                        name="password"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label for="signin-password"
                          >{{ $t("form.password") }}
                          <sup class="text-danger">*</sup></label
                        >
                        <input
                          type="password"
                          class="form-control"
                          :placeholder="$t('form.password')"
                          v-model="password"
                          :class="{ 'is-invalid': errors.length }"
                          name="password"
                          id="signin-password"
                        />
                        <span v-cloak class="text-danger small">{{
                          errors[0]
                        }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      class="btn btn-primary w-100"
                      :disabled="invalid"
                      type="submit"
                    >
                      {{ $t("connexion") }}
                    </button>
                    <div
                      v-if="monitor.visible"
                      class="px-1 text-center"
                      :class="monitor.type"
                    >
                      {{ monitor.message }}
                    </div>
                    <div class="modal-login__footer mt-2">
                      <div>
                        {{ $t("noAccount") }}
                      </div>
                      <div>
                        <a href="#" class="mr-2" @click="openSignUp()">{{
                          $t("register")
                        }}</a>
                        <a href="#" @click="openFogotPassword()">{{
                          $t("forgotPassword")
                        }}</a>
                      </div>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { ValidationProvider, extend } from "vee-validate";

import Qs from "qs";

export default {
  name: "LoginModal",
  data() {
    return {
      disableSubmit: false,
      email: null,
      password: null,
      monitor: {
        visible: false,
        message: "",
        type: "text-warning",
      },
    };
  },
  created() {
    let ajaxurl = "/wp-admin/admin-ajax.php";
    window.ajaxurl = ajaxurl;
  },
  computed: {
    ...mapFields(["cart", "user"]),
  },
  methods: {
    login() {
      let data = {};
      this.monitor.visible = false;
      this.monitor.message = "";
      this.monitor.type = "";
      data.email = this.email;
      data.password = this.password;
      this.disableSubmit = true;
      this.$store
        .dispatch("login", data)
        .then((response) => {
          if (response.status === 200) {
            this.monitor.type = "text-success";
            this.monitor.visible = true;
            this.monitor.message = this.$t("connectedSuccessMsg");
            setTimeout(() => {
              this.closeModal();
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.status == 404) {
              this.monitor.type = "text-danger";
              this.monitor.message = this.$t("errors.emailError");
              this.monitor.visible = true;
              this.email = "";
              this.password = "";
              this.$refs.observer.reset();
              setTimeout(() => {
                this.monitorHide();
              }, 5000);
            } else {
              setTimeout(() => {
                this.monitor.type = "text-warning";
                this.monitor.message = this.$t("errors.serverError");
                this.monitor.visible = true;
              }, 900);
              this.monitorHide();
            }
          }
        });
    },
    openSignUp() {
      $("#loginModal").modal("hide");
      $("#signupModal").modal("show");
    },
    openFogotPassword() {
      $("#loginModal").modal("hide");
      $("#ForgotPasswordModal").modal("show");
    },
    closeModal() {
      this.email = "";
      this.password = "";
      this.$refs.observer.reset();
      $("#loginModal").modal("hide");
    },
    monitorHide() {
      this.monitor.type = "";
      this.monitor.message = "";
      this.monitor.visible = false;
    },
  },
};
</script>

<style scoped></style>
